import http from "./httpService";
import { taxLegalCaseUrl } from "./taxLegalService";
import getApiEndpoint from "./apiEndpoint";
import { EntityRecording, EntityRecordingId, PatchEntityRecording, SendEntityRecording, StoreEntityRecording } from "../types/entityRecordingTypes";
import { IdType } from "../types/appTypes";

const apiEndpoint = `${getApiEndpoint()}/entityRecording`;

// PUT|PATCH       api/v1/entityRecording/{entityRecording} entityRecording.up…
export function patchEntityRecording(entityRecordingId: EntityRecordingId, data: PatchEntityRecording) {
  return http.patch<{ data: EntityRecording }>(`${apiEndpoint}/${entityRecordingId}`, data);
}
// DELETE          api/v1/entityRecording/{entityRecording} entityRecording.de…
export function deleteEntityRecording(entityRecordingId: EntityRecordingId) {
  return http.delete<true>(`${apiEndpoint}/${entityRecordingId}`);
}
// POST            api/v1/entityRecording/{entityRecording}/send entityRecordi…
export function sendEntityRecording(entityRecordingId: EntityRecordingId, data: SendEntityRecording) {
  return http.post<true>(`${apiEndpoint}/${entityRecordingId}/send`, data);
}

// GET|HEAD        api/v1/taxLegalCase/{taxLegalCase}/entityRecording taxLegal…
export const taxLegalEntityRecordingUrl = (caseId: IdType) => `${taxLegalCaseUrl(caseId)}/entityRecording`
export function getTaxLegalEntityRecording(caseId: IdType) {
  return http.get<EntityRecording[]>(`${taxLegalCaseUrl(caseId)}/entityRecording`);
}
// POST            api/v1/taxLegalCase/{taxLegalCase}/entityRecording taxLegal…
export function storeTaxLegalEntityRecording(caseId: IdType, data: StoreEntityRecording) {
  return http.post<{ data: EntityRecording }>(`${taxLegalCaseUrl(caseId)}/entityRecording`, data);
}
